module.exports = __webpack_public_path__ + "static/mailbox-ad57164941bf149967cc65e3564f7559.png";